import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { User,ChevronUp, ChevronDown } from "lucide-react";
import a3 from '../assets/dd1.webp'

// Dummy testimonial data
const testimonials = [
  {
    name: "Ravi Kumar",
    role: "Farmer, Punjab",
    text: "Drone Didi helped me improve crop monitoring and reduce costs.",
  },
  {
    name: "Anita Sharma",
    role: "Entrepreneur, UP",
    text: "Training was excellent! I feel confident flying agri-drones now.",
  },
  {
    name: "Suresh Yadav",
    role: "Agri Tech Student",
    text: "Best initiative for rural youth. Practical, hands-on, and inspiring!",
  },
  {
    name: "Priya Singh",
    role: "Drone Pilot",
    text: "The project gave me confidence and work opportunities in my village.",
  },
];

const TestimonialCarousel = () => {
  return (
    <div className="relative w-full p-8 max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
      {/* Left Side Image */}
      <div className="flex justify-center">
        <img
          src={a3}
          alt="Drone Didi"
          className="w-500 h-auto"
        />
      </div>

      {/* Right Side Vertical Swiper */}
      <div className="relative">
        {/* Swiper */}
        <Swiper
          direction="vertical"
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          slidesPerView={2}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          className="h-[400px] px-6"
        >
          {testimonials.map((t, i) => (
            <SwiperSlide key={i}>
            
               <div className="flex items-center gap-3">
  <div className="bg-white shadow-md rounded-xl p-6 border border-gray-100 hover:shadow-lg transition">
    <p className="text-gray-700 mb-4">“{t.text}”</p>
    
    <div className="flex items-center gap-2">
      <User className="w-5 h-5 text-green-600" /> {/* ✅ User icon name ke aage */}
      <h4 className="font-semibold text-lg text-gray-900">{t.name}</h4>
    </div>
    
    <span className="text-sm text-gray-500">{t.role}</span>
  </div>
</div>

            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation Buttons */}
        <div className="absolute -right-14 top-1/2 transform -translate-y-1/2 flex flex-col gap-3">
          <button className="swiper-button-prev-custom bg-green-800 text-white p-3 rounded-full shadow hover:bg-green-600 transition">
            <ChevronUp size={20} />
          </button>
          <button className="swiper-button-next-custom bg-green-800 text-white p-3 rounded-full shadow hover:bg-green-600 transition">
            <ChevronDown size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
